import { toEnumClass } from "./toEnumClass.js";
const toEnumStateClass = (name, namedDefault) => toEnumClass("is-", name, namedDefault);
export {
  toEnumStateClass
};
//# sourceMappingURL=toEnumStateClass.js.map
